export interface IEdgeDisplayModel {
  lineStyle: string;
  lineColor: string;
  lineWeight: string;
  sourceArrow: string;
  targetArrow: string;
}

export class EdgeDisplayModel implements IEdgeDisplayModel {
  constructor(
    public lineStyle: string,
    public lineColor: string,
    public lineWeight: string,
    public sourceArrow: string,
    public targetArrow: string,
  ) {}
}
